import { format } from 'date-fns'

const regexDate =
  /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/

export const formatDateString = (date: string) => {
  const _date = new Date(date.replace(/-/g, '/').replace(/T.+/, ''))

  return format(_date, 'MMMM dd, yyyy')
}

export const formatTimeString = (date: string) => {
  const match = regexDate.exec(date)

  return match?.[13] // 23:00
}
